import { httpClientPrivate } from '@/libs/httpClient'
import config from '@/config'
import { Query, TreatmentTypeResponseType } from './type'
import { useQuery, UseQueryResult } from '@tanstack/react-query'

export const fetchTreatmentType = async (
  policyNumber: string,
): Promise<TreatmentTypeResponseType[]> => {
  const url = `${config.restUrl}/v1/backoffice/e-claim/treatment-type?policyNumber=${policyNumber}`
  const response = await httpClientPrivate.get<TreatmentTypeResponseType[]>(url)
  return response.data
}

export const useTreatmentType = (
  query: Query,
): UseQueryResult<TreatmentTypeResponseType[], Error> => {
  const queryKey = ['useTreatmentType', query]
  const queryFn = async () => fetchTreatmentType(query.policyNumber)
  const queryResult = useQuery({ queryKey, queryFn, enabled: !!query.policyNumber })
  return { ...queryResult }
}
